/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Inclusive_Shell_PersistInputs */

const fr_soft_inclusive_shell_persist = /** @type {(inputs: Soft_Inclusive_Shell_PersistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous n'avez pas encore de programme personnel assigné. Contactez votre coach pour en
						créer un.`)
};

/**

* @param {Soft_Inclusive_Shell_PersistInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const soft_inclusive_shell_persist = /** @type {((inputs?: Soft_Inclusive_Shell_PersistInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Inclusive_Shell_PersistInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_soft_inclusive_shell_persist(inputs)
});